import { defineStore } from 'pinia';
import { ISentinelApiKey, ICompanies, ISentinelRouteMap as ISentinelRouteMap, IWebserviceAccounts, ISentinelRoute } from '../Api/Sentinel';
import { ChoiceApi } from '../../LibMain';
import { ref } from 'vue';


export const useSentinelStore = defineStore('SentinelStore', () => {

    const keys = ref<ISentinelApiKey[]>();
    
    async function getKeys():Promise<ISentinelApiKey[] | undefined>{
        if(!keys.value){
            keys.value = await ChoiceApi.sentinel.getAllKeys();
        }
        return keys.value;
    }
    async function refreshKeysAndMap(){
        keys.value = await ChoiceApi.sentinel.getAllKeys();
        sentinelRouteMap.value = await ChoiceApi.sentinel.getSentinelRouteMap();
    }
    async function getKey(id:number):Promise<ISentinelApiKey | undefined>{
        await getKeys();
        return keys.value?.find(o => o.sentinelApiKeyID === id);
    }
    
    const companies = ref<ICompanies[]>();

    async function getAllCompanies():Promise<ICompanies[] | undefined>{
        if(!companies.value){
            companies.value = await ChoiceApi.sentinel.getAllCompanies();
        }
        return companies.value;
    }

    const webserviceAccounts = ref<IWebserviceAccounts[]>();

    async function getAllWebserviceAccounts():Promise<IWebserviceAccounts[] | undefined>{
        if(!webserviceAccounts.value){
            webserviceAccounts.value = await ChoiceApi.sentinel.getAllWebserviceAccounts();
        }
        return webserviceAccounts.value;
    }


    const sentinelRouteMap = ref<ISentinelRouteMap[]>();

    async function getSentinelRouteMap():Promise<ISentinelRouteMap[] | undefined>{
        if(!sentinelRouteMap.value){
            sentinelRouteMap.value = await ChoiceApi.sentinel.getSentinelRouteMap();
        }
        return sentinelRouteMap.value;
    }

    const sentinelRoute = ref<ISentinelRoute[]>();

    async function getSentinelRoute():Promise<ISentinelRoute[] | undefined>{
        if(!sentinelRoute.value){
            sentinelRoute.value = await ChoiceApi.sentinel.getSentinelRoute();
        }
        return sentinelRoute.value;
    }

    function storeMap(newMap:ISentinelRouteMap[] | undefined){
        sentinelRouteMap.value = newMap;
    }
    async function updateKey(newKeyData:ISentinelApiKey) {
        await getKeys();
        if(!keys.value){
            return;
        }
        const index = keys.value?.findIndex(o => o.sentinelApiKeyID === newKeyData.sentinelApiKeyID);
        keys.value[index] = newKeyData;
    }
    return {keys, getKeys, getKey, getAllCompanies, getSentinelRouteMap, getSentinelRoute,storeMap, updateKey, getAllWebserviceAccounts, refreshKeysAndMap};
});